import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { VersionService } from './version.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { httpInterceptor } from './core/shared/interceptors/http.interceptor';


import { registerLocaleData } from '@angular/common';
import localePE from '@angular/common/locales/es-PE';
import { provideNativeDateAdapter } from '@angular/material/core';
registerLocaleData(localePE, 'es-PE');

export function initApp(versionService: VersionService) {
  return () => versionService.loadVersion();
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [VersionService],
      multi: true
    },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([httpInterceptor])
    ),
    importProvidersFrom([BrowserAnimationsModule]),
    { provide: LOCALE_ID, useValue: 'es-PE' },
    provideNativeDateAdapter()
  ]
};
